"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const ContextMenu_1 = __importDefault(require("../ContextMenu/ContextMenu"));
const utils_1 = require("../utils");
const styled_1 = __importDefault(require("../utils/styled"));
const Icon_1 = require("../Icon");
const StyledContextMenu = styled_1.default(ContextMenu_1.default)(({ theme }) => ({
    " > div:focus > div": Object.assign({}, utils_1.inputFocus({ theme }), { backgroundColor: theme.color.white, border: `1px solid ${theme.color.separators.light}`, boxShadow: "none", "> svg": {
            fill: theme.color.primary,
        } }),
    " [role='option']": {
        border: `1px solid ${theme.color.separators.light}`,
        height: "36px;",
    },
    " [role='option']:not(:last-of-type)": {
        borderBottom: 0,
    },
    " [role='listbox']": {
        padding: 0,
        top: 35,
    },
}));
const Container = styled_1.default.div(({ theme, isOpen }) => (Object.assign({ height: 36, width: 36, 
    /**
     * `textAlign` is set explicitly for when a parent sets a text-align to right-position this container,
     * leaving its content left-aligned.
     */
    textAlign: "right", fontWeight: theme.font.weight.medium, borderRadius: theme.borderRadius, display: "flex", alignItems: "center", justifyContent: "center", userSelect: "none", cursor: "pointer", marginBottom: -1.5, position: "relative", zIndex: 1 }, (isOpen && {
    backgroundColor: theme.color.white,
    border: `1px solid ${theme.color.separators.light}`,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    // Mimic a white border bottom to avoid issue cut corner / jumping issue
    ":after": {
        content: "''",
        backgroundColor: theme.color.white,
        height: 2,
        position: "absolute",
        zIndex: 1,
        right: 0,
        bottom: -1,
        left: 0,
    },
    "@media (-webkit-min-device-pixel-ratio: 2) (min-resolution: 192dpi)": {
        bottom: -1.5,
        left: 0.5,
    },
    "> svg": {
        fill: theme.color.primary,
        cursor: "pointer",
    },
}), { ":hover, :focus": {
        backgroundColor: theme.color.white,
        border: `1px solid ${theme.color.separators.light}`,
        "> svg": {
            fill: theme.color.primary,
            cursor: "pointer",
        },
    }, "> svg": {
        cursor: "pointer",
    } })));
const ActionMenu = (_a) => {
    var { items } = _a, props = __rest(_a, ["items"]);
    return (React.createElement(StyledContextMenu, Object.assign({ anchored: true, align: "right" }, props, { items: items, condensed: true }), isOpen => {
        const iconColor = isOpen ? "primary" : "color.text.lighter";
        return (React.createElement(Container, { isOpen: isOpen },
            React.createElement(Icon_1.DotMenuIcon, { size: 16, color: iconColor })));
    }));
};
exports.default = ActionMenu;
//# sourceMappingURL=ActionMenu.js.map